var Footer = function(){

    'use strict';

    var $ = jQuery;    var instances = [];


    function onReady() {
        $('.module.footer').each(function () {
            instances.push(initInstance($(this)));
        });
    }

    function initInstance(view) {

        // Private properties
        // * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

        var $view = view,
            id = $view.data('id');

        // Private methods
        // * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

        // instance object
        var instance = {
            init: function () {
                // Remove this lines this and the next line
            }
        };

        instance.init();
        return instance;
    }

    // DOMContentLoaded
    $(onReady);

}

Footer();
